export { default } from "./EliminaProductos";
